import { useEffect } from 'react'
import { HeroSection } from '@/components/landing/HeroSection'
import { AgitationSection } from '@/components/landing/AgitationSection'
import { SocialProofSection } from '@/components/landing/SocialProofSection'
import { FeaturesSection } from '@/components/landing/FeaturesSection'
import { DeliverablesSection } from '@/components/landing/DeliverablesSection'
import { TestimonialsSection } from '@/components/landing/TestimonialsSection'
import { QualificationSection } from '@/components/landing/QualificationSection'
import { FinalCTASection } from '@/components/landing/FinalCTASection'

const Index = () => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <div className="bg-black min-h-screen">
      <HeroSection />
      <AgitationSection />
      <SocialProofSection />
      <FeaturesSection />
      <DeliverablesSection />
      <TestimonialsSection />
      <QualificationSection />
      <FinalCTASection />
    </div>
  )
}

export default Index
